












 















const node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "errorMessage"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventId"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "content",
        "variableName": "content"
      },
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "errorMessage",
        "variableName": "errorMessage"
      },
      {
        "kind": "Variable",
        "name": "eventId",
        "variableName": "eventId"
      }
    ],
    "concreteType": "SubmitErrorFeedbackSuccess",
    "kind": "LinkedField",
    "name": "submitErrorFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSubmitErrorFeedbackMutation",
    "selections": (v4/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v3/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useSubmitErrorFeedbackMutation",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "id": "m_B0r4u8WSKIDG_z8ObO_tQA",
    "metadata": {},
    "name": "useSubmitErrorFeedbackMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "f9e3fc36644c860ab20b9e15d3913732";

export default node;
